import React from "react"
import SurveyBoxMandu from "../SurveyBoxMandu"

export const ModelItem = (props) => (
  <div className="models-list-item">
    <SurveyBoxMandu
      item={props.item}
      onClick={() => {
        props.getSurveyWatcher(props.item.id_survey)
        props.setStateFrom("idSurveyCopy", props.item.id_survey)
        props.setStateFrom("clickedModel", true)
        props.setStateFrom("modalCreate", true)
        props.setStateFrom("type", String(props.item.id_survey_type))
        // props.setStateFrom("manduSurveyDrawer", true)
        props.getSurveyEnpsWatcher(props.item.id_survey)
        props.getSurveyQualitativeWatcher(props.item.id_survey)
      }}
    />
    {/* <div className='models-list-type'>
      <Icon type='question-circle' theme='filled' style={{ color: '#D8D8D8', alignSelf:'center', fontSize: '16px' }} />
      <span>Tipo de organización</span>
    </div> */}
  </div>
)
